import { render, staticRenderFns } from "./KernelPackageReturnInfo.vue?vue&type=template&id=ff6b7a4a&"
import script from "./KernelPackageReturnInfo.vue?vue&type=script&lang=js&"
export * from "./KernelPackageReturnInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports